export default __webpack_public_path__ + "static/media/classroomLogin.5371c7ca.png";